import PropTypes from 'prop-types';
import React from 'react';
import { Link } from '@bibliocommons/base-links';
import Heading from '@bibliocommons/heading';

import cardShape from 'app/shapes/cardShape';

export default function ContentCardTitle({ card, tagName, handleClick }) {
  return (
    <Heading tagName={tagName} size="medium" className="cp-content-card-title">
      <Link href={card.get('url')} dataKey="card-link" handleClick={() => handleClick(card)}>
        {card.getIn(['title', 'text'])}
      </Link>
    </Heading>
  );
}

ContentCardTitle.propTypes = {
  card: cardShape.isRequired,
  tagName: PropTypes.string,
  handleClick: PropTypes.func
};

ContentCardTitle.defaultProps = {
  tagName: 'h3'
};
